import {
  Button,
  FormControl,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Text,
  Input,
  Checkbox,
  useToast,
  FormLabel,
  IconButton,
  HStack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  flexbox,
} from "@chakra-ui/react";
import { Menus } from "../../../components/Menu/idex";
import { useEffect, useState } from "react";
import { api } from "../../../Api/ApiService";
import { AxiosError } from "axios";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { StylesFormControl, Container, StyledTable } from "./styles";
import { NotePencil, Trash } from "@phosphor-icons/react";
import Alert from 'sweetalert2';

interface IInputs {
  nome: string;
  local: string;
  duracao: string;
}

interface InputValue {
  date: string;
  manha: boolean;
  tarde: boolean;
  noite: boolean;
}
interface IInforTable {
  col1: string;
  col2: string;
  col3: string;
  col4?: string;
  id: string;
}

interface IInforEvento {
  evento_id: string;
  nome: string;
  local: string;
  duracao: number;
  horario: JSON;
}

const Eventos = () => {
  const toast = useToast();
  const [dataResultValue, setDataResultValue] = useState<IInforTable[]>([]);
  const [dadosEvento, setDadosEvento] = useState<IInforEvento[]>([]);
  const [evento, setEvento] = useState<IInforEvento>();
  const [modoModal, setModoModal] = useState(0);
  const [idEventoEdite, setIdEventoEdite] = useState<string>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset: resetForm,
  } = useForm<IInputs>();
  const [inputCount, setInputCount] = useState<number>();
  const [inputValues, setInputValues] = useState<Array<InputValue>>(
    Array(inputCount).fill({
      date: "",
      manha: false,
      tarde: false,
      noite: false,
    })
  );

  const handleInputChange = (index: number, field: string, value: any) => {
    const newInputValues = [...inputValues];
    newInputValues[index] = { ...newInputValues[index], [field]: value };
    setInputValues(newInputValues);
  };

  const handleCountChange = (count: number) => {
    setInputCount(count);
    setInputValues(Array(count).fill(""));
  };

  const handleModalEdite = (modo: number, id_evento: string) => {
    setModoModal(modo);
    setIdEventoEdite(id_evento);
    const evento = dadosEvento.find((evento) => evento.evento_id === id_evento);
    setEvento(evento);
    
    if(evento){
      setValue("nome", evento.nome);
      setValue("local", evento.local);
      handleCountChange(evento.duracao)
      
    }
    onOpen();
  };

  async function onSubmit(data: IInputs) {
    const horario: Record<string, any> = {};

    inputValues.forEach((inputValue, index) => {
      const diaKey = `dia_${index + 1}`;
      horario[diaKey] = {
        data: inputValue.date,
        turnos: [],
      };

      if (inputValue.manha) {
        horario[diaKey].turnos.push("manha");
      }

      if (inputValue.tarde) {
        horario[diaKey].turnos.push("tarde");
      }

      if (inputValue.noite) {
        horario[diaKey].turnos.push("noite");
      }
    });

    try {
      switch (modoModal) {
        case 1:
          const result = await api.post(
            `/eventos?token=${process.env.REACT_APP_TOKEN_API}`,
            {
              nome: data.nome,
              local: data.local,
              duracao: inputCount,
              horario: horario,
            }
          );

          if (result.status === 201) {
            resetForm();
            onClose();
            getEventos();
            toast({
              title: "Cadastro realizado",
              description: result.data.message,
              status: "success",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          } else {
            toast({
              title: "Atenção",
              description:
                "Informe datas e turnos para todos os dias do evento.",
              status: "warning",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          }

          break;

        case 2:
          console.log("editarr");

          if (evento) {
            const result = await api.patch(
              `/eventos/${evento.evento_id}?token=${process.env.REACT_APP_TOKEN_API}`,
              {
                nome: data.nome,
                local: data.local,
                duracao: inputCount,
                horario: horario,
              }
            );

            resetForm();
            onClose();
            getEventos();
            toast({
              title: "Evento editado com sucesso",
              description: result.data.message,
              status: "success",
              duration: 3000,
              position: "top",
              isClosable: true,
            });
          }

          break;
        default:
          break;
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function getEventos() {
    try {
      const result = await api.get(
        `/eventos?token=${process.env.REACT_APP_TOKEN_API}`
      );
      let aux: IInforTable[] = [];
      let dados_aux: IInforEvento[] = [];
      result.data.map((evento: any) => {
        dados_aux.push(evento.infor);
        const last_index = Object.keys(evento.infor.horario).length;
        aux.push({
          col1: evento.infor.nome,
          col2: evento.infor.local,
          col3: dayjs(evento.infor.horario["dia_1"].data).format("DD/MM/YYYY"),
          col4: dayjs(evento.infor.horario[`dia_${last_index}`].data).format(
            "DD/MM/YYYY"
          ),
          id: evento.infor.evento_id,
        });
      });
      setDadosEvento(dados_aux);
      setDataResultValue(aux);
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function deleteEvento(id_evento: string) {
      await Alert.fire({
        toast: true,
        icon: "question",
        text: "Tem certeza que deseja excluir o evento?",
        showCancelButton: true,
        cancelButtonText: "Não",
        cancelButtonColor: "red",
        confirmButtonText: "Sim",
        confirmButtonColor: "#044549",
        preConfirm: () => executeDelete(),
      })
      
      async function executeDelete(){
        try{
          const result = await api.delete(
            `/eventos/${id_evento}?token=${process.env.REACT_APP_TOKEN_API}`
          ); 
          getEventos();

          toast({
            description: result.data.message,
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });

      } catch (error: AxiosError | any) {
        console.log(error);
        toast({
          title: "Erro",
          description: error.response.data,
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      }
      }
    }   
      

  useEffect(() => {
    getEventos();
  }, []);

  return (
    <>
      <Menus />
      <Container>
        <div className="title">
          <h1>EVENTOS</h1>
          <Button
            bg={"#2F2E41"}
            p={5}
            fontSize={20}
            color={"#ffffff"}
            _hover={{ background: "#1A1733" }}
            size="sm"
            onClick={() => {
              setModoModal(1);
              onOpen();
            }}
          >
            Cadastrar Evento
          </Button>
        </div>

        <TableContainer
          className="table"
          border={"1px solid #CCCCCC"}
          borderRadius={10}
          mt={35}
          bg={"#FFFFF"}
        >
          <StyledTable colorScheme="gray">
            <Thead>
              <Tr bg={"#CCCCCC"} color={"#3F3D56"}>
                <Th fontSize={22} color={"#3F3D56"}>
                  Nome
                </Th>
                <Th fontSize={22} color={"#3F3D56"}>
                  Local
                </Th>
                <Th fontSize={22} color={"#3F3D56"}>
                  Data início
                </Th>
                <Th fontSize={22} color={"#3F3D56"}>
                  Data encerramento
                </Th>
                <Th fontSize={22} color={"#3F3D56"}></Th>
              </Tr>
            </Thead>
            <Tbody overflowY={"scroll"}>
              {(() => {
                return dataResultValue.map((evento) => (
                  <Tr>
                    <Td fontSize={20}>{evento.col1}</Td>
                    <Td fontSize={20}>{evento.col2}</Td>
                    <Td fontSize={20}>{evento.col3}</Td>
                    <Td fontSize={20}>{evento.col4}</Td>
                    <Td display={"flex"} gap={8}>
                      <button onClick={() => handleModalEdite(2, evento.id)}>
                        <NotePencil size={30} color="#147706" />
                      </button>
                      <button onClick={() => deleteEvento(evento.id)}>
                        <Trash size={30} color="#c03333" />
                      </button>
                    </Td>
                  </Tr>
                ));
              })()}
            </Tbody>
          </StyledTable>
        </TableContainer>
      </Container>
      <Modal
        size={"lg"}
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            display={"flex"}
            justifyContent={"center"}
            color={"#3F3D56"}
            fontWeight={"bold"}
            fontSize={25}
          >
            {modoModal == 1 ? "Cadastrar evento" : "Editar evento"}
          </ModalHeader>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBody>
              <StylesFormControl gap={4}>
                <FormControl
                  display={"flex"}
                  flexDir={"row"}
                  justifyContent={"space-between"}
                >
                  <FormLabel fontSize={16}>Nome:</FormLabel>
                  <Input
                    type="text"
                    size={"sm"}
                    variant={"filled"}
                    borderRadius={"5px"}
                    border={"1px solid #B0BEC5"}
                    {...register("nome", {
                      required: "Campo obrigatório",
                    })}
                  />
                </FormControl>
                {errors.nome && (
                  <Text color={"red"}>{errors.nome.message}</Text>
                )}

                <FormControl
                  display={"flex"}
                  flexDir={"row"}
                  justifyContent={"space-between"}
                  gap={2}
                  mt={"1rem"}
                >
                  <FormLabel fontSize={16}>Local:</FormLabel>
                  <Input
                    type="text"
                    variant={"filled"}
                    borderRadius={"5px"}
                    border={"1px solid #B0BEC5"}
                    size={"sm"}
                    {...register("local", {
                      required: "Campo obrigatório",
                    })}
                  />
                </FormControl>
                {errors.local && (
                  <Text color={"red"}>{errors.local.message}</Text>
                )}
              </StylesFormControl>
              <FormControl
                display={"flex"}
                flexDir={"row"}
                mt={5}
                justifyContent={"space-between"}
              >
                <FormLabel fontSize={16}>
                  Quantos dias vai durar o evento?
                </FormLabel>
                {modoModal == 2?
                 <Input
                 type="number"
                 w={200}
                 min={0}
                 max={20}
                 variant={"filled"}
                 borderRadius={"5px"}
                 border={"1px solid #B0BEC5"}
                 size={"sm"}
                 isRequired
                 defaultValue={evento?.duracao}
                 onChange={(e) => handleCountChange(Number(e.target.value))}
               />
               :
               <Input
               type="number"
               w={200}
               min={0}
               max={20}
               variant={"filled"}
               borderRadius={"5px"}
               border={"1px solid #B0BEC5"}
               size={"sm"}
               isRequired
               onChange={(e) => handleCountChange(Number(e.target.value))}
             />
              }
               
              </FormControl>
            </ModalBody>
            <FormControl>
              <Text
                textAlign={"center"}
                fontSize={13}
                m={5}
                borderTop={"2px solid #cccccc"}
              >
                Para cada dia selecione uma data e o(s) período(s) de
                atendimento. Lembre-se que a duração de cada entrevista é de 15
                minutos{" "}
              </Text>
            </FormControl>
            <FormControl p={5}>
              {inputValues.map((value, index) => (
                <StylesFormControl
                  gap={4}
                  mb={3}
                  display={"flex"}
                  alignItems={"center"}
                >
                  <InputGroup
                    gap={3}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Text>Dia {index + 1}:</Text>
                    <Input
                      size={"sm"}
                      type="date"
                      w={170}
                      borderRadius={"5px"}
                      isRequired
                      onChange={(e) =>
                        handleInputChange(index, "date", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup gap={4} justifyContent={"center"}>
                    <Checkbox
                      isChecked={value.manha}
                      onChange={(e) =>
                        handleInputChange(index, "manha", e.target.checked)
                      }
                    >
                      Manhã
                    </Checkbox>
                    <Checkbox
                      isChecked={value.tarde}
                      onChange={(e) =>
                        handleInputChange(index, "tarde", e.target.checked)
                      }
                    >
                      Tarde
                    </Checkbox>
                    <Checkbox
                      isChecked={value.noite}
                      onChange={(e) =>
                        handleInputChange(index, "noite", e.target.checked)
                      }
                    >
                      Noite
                    </Checkbox>
                  </InputGroup>
                </StylesFormControl>
              ))}
            </FormControl>
            <ModalFooter>
              <InputGroup gap={8} display={"contents"}>
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  marginRight={"5"}
                  backgroundColor={"white"}
                  onClick={() => {
                    resetForm();
                    onClose();
                  }}
                >
                  Cancelar
                </Button>

                <Button
                  type="submit"
                  w={40}
                  h={8}
                  border={"1px solid #044549"}
                  color={"#044549"}
                  backgroundColor={"white"}
                  fontWeight={"medium"}
                >
                  Salvar
                </Button>
              </InputGroup>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};

export { Eventos };
